export default __webpack_public_path__ + "static/media/favorite_mobile.3ab001f3.svg";